import { useEffect, useRef, useState } from 'react'

/**
 * @template T
 * @param {T | (() => T)} initialState
 * @returns {[T, React.Dispatch<React.SetStateAction<T>>, React.MutableRefObject<T>]}
 */
export function useRefState(initialState) {
  const [state, setState] = useState(initialState)
  const ref = useRef(state)

  useEffect(() => {
    ref.current = state
  }, [state])

  return [state, setState, ref]
}
